import { thirdPartyTracking } from 'global/tagging/globalTaggingEvents';

const addToCartTracking = () => {
	window.od.events.subscribe('addToCart_Submitting', data => {
		let trackingMeta = data.form.getAttribute('data-tracking-meta');

		if (trackingMeta) {
			trackingMeta = JSON.parse(trackingMeta);
			thirdPartyTracking(trackingMeta.onAddToCartUrl);
		}
	});
};

export default addToCartTracking;
